import { requestWithToken } from "../utils/apis";

export const updateToken = async (payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/user/update/token`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
